import { View } from "../"
export default View
